import { useMutation, useQueryClient } from 'react-query';
import { LimitedSchemaMutationOptions } from '@frontend/react-query-helpers';
import { endpointKeys as queryEndpointKeys } from '../../queries';
import { SchemaDigitalForms } from '../../service';
import { IO } from '../../types';
import { endpointKeys } from '../keys';

/**
 * @deprecated use useUpdateReviewRequiredFlagForFormV2 instead
 */
export const useUpdateReviewRequiredFlagForForm = <E = unknown, C = unknown>(
  options?: LimitedSchemaMutationOptions<IO.UpdateReviewRequiredFlagForForm, E, C>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: endpointKeys.updateReviewRequiredFlagForForm,
    mutationFn: (req) => SchemaDigitalForms.UpdateFormReviewRequiredFlag(req),
    ...options,
    onSuccess: async (...successArgs) => {
      await queryClient.invalidateQueries(queryEndpointKeys.formDetails);

      if (options?.onSuccess) {
        options.onSuccess(...successArgs);
      }
    },
  });
};

export const useUpdateReviewRequiredFlagForFormV2 = <E = unknown, C = unknown>(
  options?: LimitedSchemaMutationOptions<IO.UpdateFormReviewRequiredFlagV2, E, C>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: endpointKeys.updateReviewRequiredFlagForFormV2,
    mutationFn: (req) => SchemaDigitalForms.UpdateFormReviewRequiredFlagV2(req),
    ...options,
    onSuccess: async (...successArgs) => {
      await queryClient.invalidateQueries(queryEndpointKeys.formDetails);

      if (options?.onSuccess) {
        options.onSuccess(...successArgs);
      }
    },
  });
};

export const useDeleteFormV2 = <E = unknown, C = unknown>(
  options?: LimitedSchemaMutationOptions<IO.DeleteFormV2, E, C>
) => {
  return useMutation({
    mutationKey: endpointKeys.deleteFormV2,
    mutationFn: (req) => SchemaDigitalForms.DeleteFormV2(req),
    ...options,
  });
};

/**
 * @deprecated use useImportESMedialHistoryFormsV2 instead
 */
export const useImportESMedialHistoryForms = <E = unknown, C = unknown>(
  options?: LimitedSchemaMutationOptions<IO.ImportESMedialHistoryForms, E, C>
) => {
  return useMutation({
    mutationKey: endpointKeys.importEaglesoftMedicalHistoryForms,
    mutationFn: (req) => SchemaDigitalForms.InsertESMedicalHistoryForms(req),
    ...options,
  });
};
export const useImportESMedialHistoryFormsV2 = <E = unknown, C = unknown>(
  options?: LimitedSchemaMutationOptions<IO.InsertESMedicalHistoryFormsV2, E, C>
) => {
  return useMutation({
    mutationKey: endpointKeys.importEaglesoftMedicalHistoryForms,
    mutationFn: (req) => SchemaDigitalForms.InsertESMedicalHistoryFormsV2(req),
    ...options,
  });
};

export const useUpdateFormLocationAccess = <E = unknown, C = unknown>(
  options?: LimitedSchemaMutationOptions<IO.UpdateFormLocationAccess, E, C>
) => {
  return useMutation({
    mutationKey: endpointKeys.updateFormLocationAccess,
    mutationFn: (req) => SchemaDigitalForms.UpdateFormLocationAccess(req),
    ...options,
  });
};
